import '../styles/globals.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import Head from 'next/head'
import HeaderComponent from '../components/header.component';
import { useEffect } from 'react';

function MyApp({ Component, pageProps }) {
  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return <div className="container">
    <Head>
      <title>{pageProps ? pageProps.title : 'Home Page'}</title>
      <meta name="viewport" content="width=device-width,initial-scale=1" />
    </Head>
    <HeaderComponent></HeaderComponent>
    <Component {...pageProps} />
  </div>
}

export default MyApp
